import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import Utils from '@nykaa/deals-utils/basic';
import React, { useEffect, useRef, useState } from 'react';
import Chips from './Chips';
import { Wrapper } from './css';
const CategoryFilters = (props) => {
    const { filterTags, styles, handleSelected, isDesktop, trackingData, remoteConfigs, } = props;
    const [filtersTransition, setFilterTransition] = useState(false);
    const initialFilterValues = {
        1: 'all',
    };
    const wrapperRef = useRef(null);
    const [selectedCategories, setSelectedCategories] = useState(initialFilterValues);
    useEffect(() => {
        if (filtersTransition) {
            wrapperRef.current.scrollLeft = 0;
        }
    }, [filtersTransition]);
    const clickHandler = (clickData) => {
        ImpressionsHandler.handleClick(clickData);
    };
    const handleFilterClick = (buttonProps, isSelected) => {
        const { button_text, button_position } = buttonProps;
        let categoriesObj = Object.assign({}, selectedCategories);
        const isAllTag = (categoriesObj[1] === 'all');
        if (isAllTag) {
            setFilterTransition(false);
            delete categoriesObj[1];
        }
        if (button_text !== 'all') {
            if (!isSelected) {
                categoriesObj = Object.assign(Object.assign({}, categoriesObj), { [button_position]: button_text });
                handleSelected(Object.values(categoriesObj));
                setSelectedCategories(categoriesObj);
                clickHandler(Object.assign(Object.assign({}, buttonProps), { widget_filters_selected: categoriesObj }));
            }
            else {
                delete categoriesObj[button_position];
                if (Utils.isEmpty(categoriesObj)) {
                    setFilterTransition(true);
                    clickHandler(Object.assign(Object.assign({}, buttonProps), { widget_filters_selected: initialFilterValues }));
                    handleSelected(Object.values(initialFilterValues));
                    setSelectedCategories(initialFilterValues);
                    return initialFilterValues;
                }
                handleSelected(Object.values(categoriesObj));
                setSelectedCategories(categoriesObj);
                clickHandler(Object.assign(Object.assign({}, buttonProps), { widget_filters_selected: categoriesObj }));
            }
        }
        else {
            handleSelected(Object.values(initialFilterValues));
            setSelectedCategories(initialFilterValues);
            clickHandler(Object.assign(Object.assign({}, buttonProps), { widget_filters_selected: initialFilterValues }));
        }
        return categoriesObj;
    };
    const { margin, interItem, } = styles;
    return (React.createElement(Wrapper, { isDesktop: isDesktop, ref: wrapperRef, margin: margin, gap: interItem }, filterTags.map((filter, index) => (React.createElement(Chips, { isDesktop: isDesktop, cssStyle: styles, text: filter, position: index + 1, trackingData: trackingData, selectedTags: selectedCategories, handleTagClick: handleFilterClick, remoteConfigs: remoteConfigs })))));
};
export default CategoryFilters;
